/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped.call(this);
};
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped,
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari"
                 );

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari.forceFocus = function(e) {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        var _target = e.target;
        var _nodeN = _target.nodeName.toUpperCase();
        var isMatchedTag = _nodeN == "INPUT" || _nodeN == "SELECT" || _nodeN == "TEXTAREA";

        if ((com.inq.utils.Capabilities.isSafari() || com.inq.utils.Capabilities.isChromeiOS()) && com.inq.utils.Capabilities.isMobile() && isMatchedTag) {
            if (!_target.onfocus) {
                _target.blur();
                _target.onfocus = com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus;
                _target.onblur = com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur;
            }

        }
    }
};

